"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDDViewCustomAttributes = exports.addContextAttributes = exports.removePreviousContextAttributes = exports.previousContextKeys = exports.DDGlobalContextKeys = exports.getDatadogRumInstance = void 0;
var nucleus_logging_1 = require("@cvent/nucleus-logging");
var LOG = new nucleus_logging_1.Logger('datadogUtils');
/** Add type information to datadog instance */
var getDatadogRumInstance = function () {
    return typeof window === 'undefined' ? undefined : window.DD_RUM;
};
exports.getDatadogRumInstance = getDatadogRumInstance;
// exporting for testing purposes
exports.DDGlobalContextKeys = [];
exports.previousContextKeys = [];
/**
 * Removes previous context attributes set by the previous metric
 */
var removePreviousContextAttributes = function () {
    var ddRumSDK = (0, exports.getDatadogRumInstance)();
    // Remove attributes set by the last metric recorded
    exports.previousContextKeys.forEach(function (key) {
        ddRumSDK.removeGlobalContextProperty(key);
    });
};
exports.removePreviousContextAttributes = removePreviousContextAttributes;
/**
 * Adds the properties for the current metric into the DD View Custom attributes
 *
 * @param context
 * @param prefix
 */
var addContextAttributes = function (context, prefix) {
    if (prefix === void 0) { prefix = 'cvent_'; }
    var ddRumSDK = (0, exports.getDatadogRumInstance)();
    if (context && ddRumSDK) {
        (0, exports.removePreviousContextAttributes)();
        exports.previousContextKeys = [];
        // Add current metrics attributes to the DD View
        Object.keys(context).forEach(function (key) {
            // we don't want pageTimings attributes to be added to the global context
            if (!(key === null || key === void 0 ? void 0 : key.endsWith('pageTimings')) && !exports.DDGlobalContextKeys.includes(key)) {
                exports.previousContextKeys.push(key);
                ddRumSDK.setGlobalContextProperty("".concat(prefix).concat(key), context[key]);
            }
        });
    }
};
exports.addContextAttributes = addContextAttributes;
/**
 * Sets custom base attributes to all actions
 * @param context
 * @param prefix
 */
var setDDViewCustomAttributes = function (context, prefix) {
    if (prefix === void 0) { prefix = 'cvent_'; }
    var ddRumSDK = (0, exports.getDatadogRumInstance)();
    if (ddRumSDK) {
        var data = Object.keys(context).reduce(function (a, c) { return ((a["".concat(prefix).concat(c)] = context[c]), a); }, {});
        ddRumSDK.setGlobalContext(data);
        Object.keys(data).forEach(function (key) {
            exports.DDGlobalContextKeys.push(key);
        });
        // Make sure there are no duplicate keys
        exports.DDGlobalContextKeys = Array.from(new Set(exports.DDGlobalContextKeys));
    }
};
exports.setDDViewCustomAttributes = setDDViewCustomAttributes;
